import { render } from "./VConfirm.vue?vue&type=template&id=cbc6bd28"
import script from "./VConfirm.vue?vue&type=script&lang=js"
export * from "./VConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__